import axios, { AxiosError } from "axios";

import { MHPTreatmentReportDto } from "@teamprevent/common/mentalHealthPractitionerTreatment/models";
import { ConsultationDetails } from "@teamprevent/common/model";
import { parseConsultationModel } from "@teamprevent/common/consultations/models";
import { ServerModelWithDateStrings } from "@teamprevent/common/utils";

const apiUrl = "/api/mentalHealthPractitionerTreatment";

const loadReportByViewTaskId = async (ohCaseId: string, viewReportTaskId: string): Promise<MHPTreatmentReportDto | null> => {
    try {
        const response = await axios.get<MHPTreatmentReportDto>(`${apiUrl}/report/${ohCaseId}/${viewReportTaskId}`);
        return response.data;
    } catch (ex) {
        const axiosError = ex as AxiosError;
        if (axiosError && axiosError.response && axiosError.response.status === 404) {
            return null;
        }

        throw ex;
    }
};

const viewReport = async (ohCaseId: string, viewReportTaskId: string): Promise<void | null> => {
    try {
        await axios.post(`${apiUrl}/report/${ohCaseId}/${viewReportTaskId}/viewed`);
    } catch (ex) {
        const axiosError = ex as AxiosError;
        if (axiosError && axiosError.response && axiosError.response.status === 404) {
            return null;
        }

        throw ex;
    }
};

const getConsultationDetailsByViewTaskId = async (ohCaseId: string, viewReportTaskId: string): Promise<ConsultationDetails | null> => {
    try {
        const response = await axios.get<
            ServerModelWithDateStrings<ConsultationDetails>
        >(`${apiUrl}/report/${ohCaseId}/${viewReportTaskId}/consultationDetails`);
        return parseConsultationModel(response.data);
    } catch (ex) {
        const axiosError = ex as AxiosError;
        if (axiosError && axiosError.response && axiosError.response.status === 404) {
            return null;
        }

        throw ex;
    }
};

export const mhpTreatmentApi = {
    loadReportByViewTaskId,
    viewReport,
    getConsultationDetailsByViewTaskId
};
